Selector.View.QuestionView = Backbone.View.extend(
/** @lends Selector.View.QuestionView# */
{	
	/** classname to give the generated element */
	className: "e_selector_item e_selector_question",
	
	/** tagname to give this generated element */
	tagName: "div",
	
	/** template to use for Underscore.js rendering */
    template: _.template($('#selector_question').html()),

    templateWarning: _.template($('#selector_warning').html()),

	events: {
        "click input[type=radio]": 	        "submitAnswer",
        "click .e_selector_button_back": 	"backOneGroup",
        "click .e_selector_button_next": 	"submitAnswer"
	},	
	
	/** Render function */
	render: function() {
		
		this.$el.html(this.template(this.model.attributes));//render the HTML

        $(".e_selector_warnings").find("[data-question="+this.model.get("ID")+"]").remove()
        if (this.model.get("WARNING")) {
            if (ele.selector.data.CONFIG.SELECTORBEHAVIOUR === "FLAT") {
                this.$el.append(this.templateWarning({
                    WARNING: this.model.get("WARNING"),
                    QUESTION: this.model.get("ID")
                }));
            } else {
                if ($(".e_selector_warnings").find("[data-question="+this.model.get("ID")+"]").length === 0) {
                    $(".e_selector_warnings").prepend(this.templateWarning({
                        WARNING: this.model.get("WARNING"),
                        QUESTION: this.model.get("ID")
                    }));
                }
            }
        }

		return this; //needed in order to chain rendering
	},

	submitAnswer: function(e) {

        var currentModel = this.model;

	    if (e.currentTarget.type === "radio" && ele.selector.data.CONFIG.SELECTORBEHAVIOUR !== "FLAT") {
	        return true; //only allow radio button answering on FLAT version
        }
		
		this.getAnswerFromForm();

		//set any answers after this to blank.
        this.model.collection.each(function(model){
            if (currentModel.get("IDNUM") < model.get("IDNUM")) {
                model.resetModel();
            }
        });

		this.model.collection.save = true;
		this.model.collection.parseAnswers();
	},

    backOneGroup: function() {
        $(".e_selector_tab .active").closest(".e_selector_tab").prev().find("a").click();
    },

    getAnswerFromForm: function(){

        this.model.set("ERROR", false);

        var $answerInputs = this.$el.find("input:checked"),
            answer = [],
            answerString;

        $answerInputs.each(function(i) {
            answer.push($(this).val());
        });

        answerString = answer.join("|");

        if (answerString === "") {
            this.model.set("ERROR", true);
        }
        this.model.set("ANSWER", answerString);

    }


});